export default {
    translations: {
        home: {
            message: ' Welcome to the new AdamWoolf.com. Here you can find out more about my activities as a professional Web Developer, Musician, Photographer and follow my blog posts...'
        }
    }
}